import React, { useState } from "react";
import { Form, Input, Button, Typography, message, Spin, Modal, Divider } from "antd";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import Login from "../../components/Login/Login";
import { applyFirmAdminSession } from "../../utils/firmAdminRedirect";

const { Title, Text, Link } = Typography;

const RegisteredEmail = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    // const onCreateAccountClick = () => {
    //     history.push(routes.verifyEmail.path);
    // };

    // const onGotoHomeClick = () => {
    //     history.push(routes.VerifyOtp.path);
    // };


    const handleConfirmSendOTP = async (values) => {
        let reqObj = {
            Email: values.email,
            Password: values.password,
            IsFirmAdmin: false,
        }
        setLoading(true);
        try {
            const res = await _NewapplicationService.userLogin(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                if (res?.data?.Obj?.Is_Subscription_Corporate_FirmAdminUser) {
                    applyFirmAdminSession(res.data.Obj, values.email, values.password, history);
                    return;
                }
               // message.success(res.data.Message || "User Logged in Successfully");
                localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("IsFirmAdminFlag", res?.data?.Obj?.IsFirmAdmin);
                localStorage.setItem("HasOtherRoleAssociation", res?.data?.Obj?.HasOtherRoleAssociation);
                localStorage.setItem("Id", res?.data?.Obj?.Id);
                localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
                localStorage.setItem("BankerId", res?.data?.Obj?.BankerId);
                localStorage.setItem("RoleId", res?.data?.Obj?.RoleId);
                localStorage.setItem("ApplicationId", res?.data?.Obj?.Id);
                localStorage.setItem("loginEmail", reqObj.Email);
                localStorage.setItem("SponserIdForFirmLogin", res?.data?.Obj?.SponserId);
                localStorage.setItem("IsKey", reqObj.Password);
                localStorage.setItem("IsSwitchFirmAdmin", JSON.stringify(false));
                localStorage.setItem("IsClient", JSON.stringify(true));
                history.push({
                    pathname: routes.myApplications.path,
                    state: { "email": values.email }
                });
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    const onFinish = (values) => {
        // confirm({
        //     title: <span className="f16">Please confirm that your email address is correct.</span>,
        //     width: 550,
        //     content: (
        //         <>
        //             <span className="f16">An OTP will be sent to: <Text className="f18" strong>{values.email}</Text></span>
        //         </>
        //     ),
        //     okText: "Yes",
        //     cancelText: "No",
        //     onOk() {
        //         handleConfirmSendOTP(values);
        //     },
        // });
        handleConfirmSendOTP(values);
    };

    const forgotPassword = () => {
        history.push(routes.forgotUserLoginPasswordSendOTP.path);
    };

    const bankerLogin = () => {
        history.push(routes.accountLogin.path);
    }

    const bankerAdminLogin = () => {
        history.push(routes.bankAdminLogin.path);
    }

    const loanOfficerLogin = () => {
        history.push(routes.accountLoginForLoanOfficer.path);
    }

    const complianceAdminLogin = () => {
        history.push(routes.complianceAdminLogin.path);
    }

    const applicantLogin = () => {
        history.push(routes.registeredEmail.path);
    }

    // const createNewAccount = () => {
    //     history.push(routes.verifyEmail.path);
    // }

    return (
        <Spin spinning={loading}>
            <Login 
                role="applicant"
                title="Client Portal"
                onFinishHandle={onFinish}
                // createNewAccount={createNewAccount}
                forgotPassword={forgotPassword}
                bankerLogin={bankerLogin}
                bankerAdminLogin={bankerAdminLogin}
                loanOfficerLogin={loanOfficerLogin}
                complianceAdminLogin={complianceAdminLogin}
                isNewAccountCreateFlag={false}
                applicantLogin={applicantLogin}
            />
            {/* <LeftLayout>
                <div className="w450 login-page">
                   <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
                        Applicant Portal
                    </Title>

                    <Form
                        name="verify-email"
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={true}
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Email is required",
                                },
                                { type: 'email', message: 'Enter a valid Email' }
                                // {
                                //     pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|org|net|edu|gov|co|ai|us|info|biz|me|io|tech|app|dev|cloud|store|xyz|tv|name|email|pro|mil|k12|state)$/,
                                //     message: "Please enter a valid email address with a valid domain (e.g., .com, .in)",
                                // },
                            ]}
                        >
                            <Input
                                placeholder="Enter Email"
                                autoComplete="email"
                                maxLength={50}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: "Password is required" }]}
                        >
                            <Input.Password autoComplete="current-password" placeholder="Enter Password" maxLength={30} />
                        </Form.Item>
                        <div style={{ textAlign: "right", marginTop: 8 }} className="forgot-text">
                            <Link onClick={() => history.push(routes.forgotUserLoginPasswordSendOTP.path)} style={{ fontWeight: "bold" }}>
                                Forgot Password? <RightOutlined />
                            </Link>
                        </div>
                        <Form.Item>
                            <Button
                                htmlType="submit"
                                className="login-btn"
                                shape="round"
                                style={{
                                    marginTop: 10,
                                }}
                            >
                                Login <RightOutlined />
                            </Button>
                        </Form.Item>

                        <Divider plain orientation="center">
                            OR
                        </Divider>

                        <Form.Item className="mt20 mb10">
                            <Link onClick={() => history.push(routes.accountLogin.path)}>
                                Banker Login <RightOutlined />
                            </Link>
                        </Form.Item>
                        <Form.Item className="mb10">
                            <Link onClick={() => history.push(routes.bankAdminLogin.path)}>
                                Bank Admin Login <RightOutlined />
                            </Link>
                        </Form.Item>    
                        <Form.Item>
                            <Link onClick={() => history.push(routes.accountLoginForLoanOfficer.path)}>
                                Loan Officer Login <RightOutlined />
                            </Link>
                        </Form.Item>
                    </Form>
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default RegisteredEmail;